<template>
  <div class="questionNaire YMCfont">
    <div class="questionNaireCon" :style="`height:${dispH - 250}px;`">
      <!-- 英文四张 -->
      <McMonnies
        v-if="whichPage === 'McMonnies'"
        @emitMcFun="emitMcFun"
        :propsChild="McMonniesProps"
      />
      <DEQ v-if="whichPage === 'DEQ'" @emitMcFun="emitMcFun" :propsChild="DEQProps" />
      <Speed v-if="whichPage === 'Speed'" @emitMcFun="emitMcFun" :propsChild="SpeedProps" />
      <!-- 中文两张 -->
      <OSDI
        ref="OSDI"
        :history="OSDIhistory"
        @emitOSDIFun="dealWidthOSDI"
        v-if="whichPage === 'OSDI'"
      />
      <DryEyeMain
        ref="DryEyeMain"
        :history="historyQuestionDryEyeMain"
        v-if="whichPage === 'DryEyeMain'"
        @emitDryEyeMainFun="dealWidthDryEyeMain"
      />
    </div>
    <!-- 用于输出pdf -->
    <webview ref="webViewRef" :src="printHtmlUrl" style="display: none"></webview>
    <!-- 按钮区域 -->
    <el-row slot="footer" class="dialog-footer">
      <el-select
        style="width: 100%; margin-right: 10px; flex: 1.2"
        v-model="optioValue"
        @change="changeSelectQuestion"
      >
        <el-option
          class="Qoption"
          v-for="item in OPTION"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          style="color: white; display: flex"
          v-html="questionnarySelectionLabel(item.label)"
        >
        </el-option>
      </el-select>
      <el-button class="btnItem" type="info" @click="showDialog">{{
        $t("langcfg.txtSubmit")
      }}</el-button>
      <el-button class="btnText">
        <div>
          {{ $t("langcfg.txtTotal") }}：<span v-if="follow">{{ resultTotal }}</span>
        </div>
        <!-- <div>
          {{ $t('langcfg.txtGradeDescription') }}：<span v-if="follow">{{
            resultTitle
          }}</span>
        </div> -->
      </el-button>
      <el-button class="btnItem" type="info" :disabled="disabled" @click="convertPdfFile">{{
        currentLanguage === "zh_CN" ? $t("langcfg.txtPrintToPDF") : $t("langcfg.txtExport")
      }}</el-button>
      <el-button class="btnItem" type="info" :disabled="disabled" @click="printReport">{{
        $t("langcfg.txtPrint")
      }}</el-button>
    </el-row>
    <!-- 分数提示框 -->
    <el-dialog
      :title="$t('langcfg.txtPrompt')"
      :visible.sync="dialogVisible"
      :width="whichPage === 'DEQ' ? '62%' : '32%'"
      style="text-align: center"
    >
      <template v-if="isCheckAllType">
        <div class="resultTotal">{{ $t("langcfg.txtTotal") }}：{{ resultTotal }}</div>
        <div class="resultTitle">
          <span>{{ $t("langcfg.txtGradeDescription") }}</span
          >：<span style="color: #409eff; font-weight: bolder">{{ resultTitle }}</span>
        </div>
        <div class="resultPrompt" v-if="whichPage === 'OSDI'">
          <div class="resultPrompt-txt">{{ $t("langcfg.txtReference") }}</div>
          <div>
            <span
              :style="`${resultTitle === $t('langcfg.txtNormal') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
            >
              {{ $t("langcfg.txtNormal") }}：0-12
            </span>
            <span
              :style="`${marginLeftOne}${resultTitle === $t('langcfg.txtMildDryEye') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
            >
              {{ $t("langcfg.txtMildDryEye") }}：13-22
            </span>
          </div>
          <div>
            <span
              :style="`${resultTitle === $t('langcfg.txtModerateDryEye') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
            >
              {{ $t("langcfg.txtModerateDryEye") }}：23-32
            </span>
            <span
              :style="`${marginLeftTwo}${resultTitle === $t('langcfg.txtSevereDryEye') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
            >
              {{ $t("langcfg.txtSevereDryEye") }}：>=33
            </span>
          </div>
        </div>
        <div class="resultPrompt" v-if="whichPage === 'DryEyeMain'">
          <div class="resultPrompt-txt">{{ $t("langcfg.txtReference") }}</div>
          <div
            :style="`${resultTitle === $t('langcfg.txtNormal') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
          >
            {{ $t("langcfg.txtNormal") }}：<7
          </div>
          <div
            :style="`${resultTitle === $t('langcfg.txtDryEye') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
          >
            {{ $t("langcfg.txtDryEye") }}：>=7
          </div>
        </div>
        <div class="resultPrompt" v-if="whichPage === 'Speed'">
          <div class="resultPrompt-txt">{{ $t("langcfg.txtReference") }}</div>
          <div
            :style="`${resultTitle === $t('langcfg.txtNormal') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
          >
            {{ $t("langcfg.txtNormal") }}：<1
          </div>
          <div
            :style="`${resultTitle === $t('langcfg.txtDryEye') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
          >
            {{ $t("langcfg.txtDryEye") }}：>=1
          </div>
        </div>
        <div class="resultPrompt" v-if="whichPage === 'McMonnies'">
          <div class="resultPrompt-txt">{{ $t("langcfg.txtReference") }}</div>
          <div
            :style="`${resultTitle === $t('langcfg.txtNormal') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
          >
            {{ $t("langcfg.txtNormal") }}：<=14.5
          </div>
          <div
            :style="`${resultTitle === $t('langcfg.txtDryEye') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
          >
            {{ $t("langcfg.txtDryEye") }}：>14.5
          </div>
        </div>
        <div class="resultPrompt" v-if="whichPage === 'DEQ'">
          <div class="resultPrompt-txt">{{ $t("langcfg.txtReference") }}</div>
          <div
            :style="`${resultTitle === $t('langcfg.txtNormal') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
          >
            {{ $t("langcfg.txtNormal") }}：<=6
          </div>
          <div
            :style="`${resultTitle === $t('langcfg.txtDryEye') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
          >
            {{ $t("langcfg.txtDryEye") }}：7-12
          </div>
          <div
            :style="`${resultTitle === $t('langcfg.txtAccompanied') ? 'color: #409EFF; font-weight: bolder;' : ''}`"
          >
            {{ $t("langcfg.txtAccompanied") }}：>12
          </div>
        </div>
      </template>
      <template v-else>
        <div class="resultTitle"><span v-html="resultTitle"></span></div>
      </template>
      <span slot="footer">
        <el-button type="primary" class="resultBut" @click="submit" v-if="isCheckAllType">
          {{ $t("langcfg.txtOK") }}
        </el-button>
        <el-button type="primary" class="resultBut" @click="hideDialog">
          {{ $t("langcfg.txtCancel") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { SELECTOPTION } from "./js/consts"; // select options
import printReport from "../mainInterface/js/printer/print";
import { isDefined, getSystemTime } from "../shared/utils";
import fileSys from "../fileoprators/fileSystem";
import { QuestionnaireSum, QuestionnaireOSDI, QuestionnaireDryEyeMain } from "./js/questionNaire"; // 计分算法函数
import { Message, Size } from "../mixins";
import McMonnies from "./components/questions/EN/McMonnies";
import DEQ from "./components/questions/EN/DEQ";
import Speed from "./components/questions/EN/Speed";
import DryEyeMain from "./components/questions/CN/DryEyeMain";
import OSDI from "./components/questions/CN/OSDI";
import EVENTS from "../bus";
const ejs = window.require("ejs");
export default {
  name: "Questionnaire",
  data() {
    return {
      printHtmlUrl: "",
      OPTION: [],
      pdfPath: fileSys.getMediaPath(`questionnaire.pdf`),
      McMonniesProps: "",
      DEQProps: "",
      SpeedProps: "",
      // EN存储已选中
      countArr: [],
      // EN存储未选中的
      noCheckArr: [],
      optioValue: window.settings.language === "en_US" ? "0" : "0",
      langauge: "",
      dialogVisible: false,
      resulExplain: "",
      resultTotal: "",
      resultTitle: "",
      whichPage: "OSDI",
      SCORE: 0,
      RESULT: "",
      disabled: true,
      emitMcFunData: "",
      historyQuestionDEQ: "",
      historyQuestionMcMonnies: "",
      historyQuestionSpeed: "",
      historyQuestionOSDI: "",
      OSDIhistory: [],
      historyQuestionDryEyeMain: [],
      isCheckAllType: false,
      follow: true,
      DryEyeMainCopy: [],
      username: "",
      pid: "",
      diaFlag: false,
      currentLanguage: ""
    };
  },
  mixins: [Message, Size],
  props: {
    currentRecord: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentPatient: Object
  },
  mounted() {
    this.initRecord();
    this.changeLanuage();
    this.currentLanguage = window.settings.language;
    this.getuser();
    if (this.resultTotal) this.disabled = false;
    this.$bus.$emit(EVENTS.hideGlobalWatting);
  },
  updated() {
    this.currentLanguage = window.settings.language;
  },
  computed: {
    language_computed() {
      return this.$store.state.dryeye.windowLanguage;
    },
    marginLeftOne() {
      switch (this.currentLanguage) {
        case "zh_CN":
          return "margin-left: 90px;";
          break;
        case "en_US":
          return "margin-left: 46px;";
          break;
        case "it":
          return "margin-left: 46px;";
          break;
        case "ja":
          return "margin-left: 185px;";
          break;
        case "de":
          return "margin-left: 30px;";
          break;
        default:
          break;
      }
    },
    marginLeftTwo() {
      switch (this.currentLanguage) {
        case "zh_CN":
          return "margin-left: 30px;";
          break;
        case "en_US":
          return "margin-left: 30px;";
          break;
        case "it":
          return "margin-left: 30px;";
          break;
        case "ja":
          return "margin-left: 30px;";
          break;
        case "de":
          return "margin-left: 30px;";
          break;
        default:
          break;
      }
    }
  },
  watch: {
    language_computed(val) {
      setTimeout(() => {
        this.optioValue = "0";
        this.whichPage = "OSDI";
        this.changeLanuage();
      }, 300);
      this.getuser();
    },
    whichPage(newValue, oldValue) {
      // this.resultTotal = 0

      // if (this.language === 'en_US') {
      //   if (oldValue === 'OSDI' || oldValue === 'DryEyeMain') {
      //     this.changeSelectQuestion()
      //     this.optioValue = '0'
      //   }
      // } else
      if (this.language === "zh_CN") {
        if (oldValue === "DEQ" || oldValue === "McMonnies") {
          this.optioValue = "0";
        } else if (oldValue === "Speed") {
          this.changeSelectQuestion();
          this.whichPage = "OSDI";
        } else {
        }
      } else {
      }
    }
  },
  methods: {
    questionnarySelectionLabel(txt) {
      if (txt.indexOf("©") >= 0) {
        return txt.replace(/©/g, "<sup>©</sup>").replace("2", "<sup>2</sup>");
      }
      return txt;
    },
    // 老病例兼容 初始化record 并第一时间上传
    initRecord() {
      if (!this.currentRecord.content.userQuestionnaire) {
        this.currentRecord.content.userQuestionnaire = {
          OSDI: [],
          DryEyeMain: [],
          Speed: [],
          DEQ: [],
          McMonnies: []
        };
      }
      this.$bus.$emit(EVENTS.updateData, this.currentRecord, {}, {}, () => {});
    },
    getuser() {
      isDefined(this.currentPatient.pid) ? (this.pid = this.currentPatient.pid) : (this.pid = "");
      isDefined(this.currentPatient.lastname)
        ? (this.username = `${this.currentPatient.firstname}${this.currentPatient.lastname}`)
        : (this.username = `${this.currentPatient.firstname}`);
    },
    changeSelectQuestion() {
      this.resultTotal = "";
      this.resultTitle = "";
      this.countArr = "";
      this.noCheckArr = "";
      this.disabled = true;
      this.QuestionnaireWillChange();
    },
    initHtml() {
      let data = {
        Speed: this.historyQuestionSpeed,
        DEQ: this.historyQuestionDEQ,
        McMonnies: this.historyQuestionMcMonnies,
        OSDI: this.historyQuestionOSDI,
        DryEyeMain: this.historyQuestionDryEyeMain,
        username: this.username,
        pid: this.pid,
        score: this.resultTotal,
        dec: this.resultTitle,
        lang: this.$i18n.messages[this.$i18n.locale].langcfg,
        country: this.language
      };

      if (this.historyQuestionDryEyeMain.length === 0) {
        data.DryEyeMain = this.countArr;
      }
      let page = this.whichPage;
      this.buildHtml(data, page);
    },
    async buildHtml(data, page) {
      let pdfhtml;
      switch (page) {
        case "Speed":
          pdfhtml = await this.renderEjs(fileSys.getQuestionnaireFilePathEN("Speed.ejs"), data);
          fileSys.writeFileSync(fileSys.getQuestionnaireFilePathEN("Speed.html"), pdfhtml);
          this.printHtmlUrl = fileSys.getQuestionnaireFilePathEN("Speed.html");
          break;
        case "DEQ":
          pdfhtml = await this.renderEjs(fileSys.getQuestionnaireFilePathEN("DEQ.ejs"), data);
          fileSys.writeFileSync(fileSys.getQuestionnaireFilePathEN("DEQ.html"), pdfhtml);
          this.printHtmlUrl = fileSys.getQuestionnaireFilePathEN("DEQ.html");
          break;
        case "McMonnies":
          pdfhtml = await this.renderEjs(fileSys.getQuestionnaireFilePathEN("McMonnies.ejs"), data);
          fileSys.writeFileSync(fileSys.getQuestionnaireFilePathEN("McMonnies.html"), pdfhtml);
          this.printHtmlUrl = fileSys.getQuestionnaireFilePathEN("McMonnies.html");
          break;
        case "OSDI":
          pdfhtml = await this.renderEjs(fileSys.getQuestionnaireFilePathCN("OSDI.ejs"), data);
          fileSys.writeFileSync(fileSys.getQuestionnaireFilePathCN("OSDI.html"), pdfhtml);
          this.printHtmlUrl = fileSys.getQuestionnaireFilePathCN("OSDI.html");
          break;
        case "DryEyeMain":
          pdfhtml = await this.renderEjs(
            fileSys.getQuestionnaireFilePathCN("DryEyeMain.ejs"),
            data
          );
          fileSys.writeFileSync(fileSys.getQuestionnaireFilePathCN("DryEyeMain.html"), pdfhtml);
          this.printHtmlUrl = fileSys.getQuestionnaireFilePathCN("DryEyeMain.html");
          break;
        default:
          break;
      }
    },
    showHistory() {
      if (this.questionnaireExists()) {
        this.SpeedProps = this.currentRecord.content.userQuestionnaire.Speed;
        this.DEQProps = this.currentRecord.content.userQuestionnaire.DEQ;
        this.McMonniesProps = this.currentRecord.content.userQuestionnaire.McMonnies;
        this.OSDIhistory = this.currentRecord.content.userQuestionnaire.OSDI;
        this.historyQuestionDryEyeMain = this.currentRecord.content.userQuestionnaire.DryEyeMain;
      }
    },
    // 中英文回显历史数据
    QuestionnaireWillChange() {
      this.language = window.settings.language;
      this.whichPage = "";
      this.showHistory();
      if (this.language === "en_US" || this.language === "it") {
        if (this.optioValue === "0") {
          this.whichPage = "DEQ";
          if (this.DEQProps && this.DEQProps.length > 0) {
            this.disabled = false;
            this.historyQuestionDEQ = this.DEQProps;
            this.countArr = this.DEQProps;
            this.dealWith();
          }
        } else if (this.optioValue === "1") {
          this.whichPage = "Speed";
          if (this.SpeedProps && this.SpeedProps.length > 0) {
            this.disabled = false;
            this.historyQuestionSpeed = this.SpeedProps;

            this.countArr = this.SpeedProps;
            this.dealWith();
          }
        } else if (this.optioValue === "2") {
          this.whichPage = "OSDI";
          if (this.OSDIhistory && this.OSDIhistory.length > 0) {
            this.disabled = false;
            this.countArr = this.OSDIhistory;
            this.dealWidthOSDI();
          }
        } else if (this.optioValue === "3") {
          this.whichPage = "McMonnies";
          if (this.McMonniesProps && this.McMonniesProps.length > 0) {
            this.disabled = false;
            this.countArr = this.McMonniesProps;
            this.historyQuestionMcMonnies = this.McMonniesProps;
            this.dealWith();
          }
        }
      } else if (this.language === "zh_CN") {
        if (this.optioValue === "0") {
          this.whichPage = "OSDI";
          if (this.OSDIhistory && this.OSDIhistory.length > 0) {
            this.disabled = false;
            this.countArr = this.OSDIhistory;
            this.dealWidthOSDI();
          }
        } else if (this.optioValue === "1") {
          this.whichPage = "DryEyeMain";
          if (this.historyQuestionDryEyeMain && this.historyQuestionDryEyeMain.length > 0) {
            this.disabled = false;
            this.countArr = this.historyQuestionDryEyeMain;
            this.dealWidthDryEyeMain();
          }
        }
      } else if (this.language === "ja") {
        // 日文
        if (this.optioValue === "0") {
          this.whichPage = "McMonnies";
          if (this.McMonniesProps && this.McMonniesProps.length > 0) {
            this.disabled = false;
            this.countArr = this.McMonniesProps;
            this.historyQuestionMcMonnies = this.McMonniesProps;
            this.dealWith();
          }
        } else if (this.optioValue === "1") {
          this.whichPage = "Speed";
          if (this.SpeedProps && this.SpeedProps.length > 0) {
            this.disabled = false;
            this.historyQuestionSpeed = this.SpeedProps;

            this.countArr = this.SpeedProps;
            this.dealWith();
          }
        } else if (this.optioValue === "2") {
          this.whichPage = "OSDI";
          if (this.OSDIhistory && this.OSDIhistory.length > 0) {
            this.disabled = false;
            this.countArr = this.OSDIhistory;
            this.dealWidthOSDI();
          }
        }
      } else {
        this.OPTION = SELECTOPTION.ZN_options;
        this.optioValue = "0";
        this.whichPage = "OSDI";
        if (this.OSDIhistory && this.OSDIhistory.length > 0) {
          this.disabled = false;
          this.countArr = this.OSDIhistory;
          this.dealWidthOSDI(); // 重新收集数据算一遍总分
        }
      }
    },
    changeLanuage() {
      this.whichPage = "";
      this.language = window.settings.language;
      if (this.language === "ja") {
        this.OPTION = SELECTOPTION.JA_options;
      } else if (this.language === "en_US") {
        this.OPTION = SELECTOPTION.EN_options;
      } else if (this.language === "it") {
        this.OPTION = SELECTOPTION.EN_options;
      } else {
        this.OPTION = SELECTOPTION.ZN_options;
      }
      this.changeSelectQuestion();
    },
    // 打印
    printFn() {
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtPrintLoading"));
      this.$refs.webViewRef.getWebContents().printToPDF({ pageSize: "A4" }, (error, data) => {
        if (error) throw error;
        fileSys.writeFile(fileSys.getMediaPath("questionnairePDF.pdf"), data, (error) => {
          if (error) {
            throw error;
          } else {
            const { printConnection } = window.printSettings;
            setTimeout(() => {
              printReport(
                { pdfPath: fileSys.getMediaPath("questionnairePDF.pdf"), printConnection },
                (error) => {
                  console.log(error);
                  if (isDefined(error)) {
                    this.notify("Failed", this.$t("langcfg.txtPrintFailed"), "error", 2000);
                  } else {
                    this.$bus.$emit(EVENTS.hideGlobalWatting);
                  }
                }
              );
            }, 1000);
          }
        });
      });
    },
    printReport() {
      this.initHtml(); // 这里需要先获取printHtml，不然会打印空白
      setTimeout(() => {
        this.printFn();
      }, 1000);
    },
    // 输出到pdf
    convertPdfFile() {
      this.initHtml();
      const { status, location } = fileSys.isUDiskExits();
      if (!status) {
        this.message(this.$t("langcfg.txtDiskIsMountedFailed"), "error", 2000);
        return;
      }
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtSavingPdf"), 100);
      const { format, singlepage } = window.printSettings.general;
      const imagePath = fileSys.combinePath(
        location,
        `Questionnaire_${getSystemTime("", "_", "")}${format}`
      );
      let filepath =
        window.printSettings.general.format === ".pdf"
          ? fileSys.combinePath(location, `Questionnaire_${getSystemTime("", "_", "")}.pdf`)
          : fileSys.getDicomTmpFilePath("report.pdf");
      setTimeout(() => {
        this.$refs.webViewRef.getWebContents().printToPDF({ pageSize: "A4" }, (error, data) => {
          if (isDefined(error)) {
            this.$bus.$emit(EVENTS.hideGlobalWatting);
            this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
          } else {
            fileSys.writeFile(filepath, data, (error) => {
              this.$bus.$emit(EVENTS.hideGlobalWatting);
              if (!isDefined(error)) {
                if (window.printSettings.general.format !== ".pdf") {
                  fileSys.convertPDF2Image(filepath, imagePath, { singlepage }, (error) => {
                    this.afterBtnEvent();
                    if (error) {
                      this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
                    } else {
                      this.message(this.$t("langcfg.txtSavePDFSuccess"), "success", 2000);
                    }
                  });
                } else {
                  this.message(this.$t("langcfg.txtSavePDFSuccess"), "success", 2000);
                }
              } else {
                this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
              }
            });
          }
        });
      }, 500);
    },
    emitMcFun(msg, noCheckArr) {
      this.follow = true;
      this.countArr = [];
      this.countArr = msg;
      this.dealWith();
      this.noCheckArr = noCheckArr;
    },
    dealWith() {
      // EN计算方法 count是结果集合
      let count = [];
      let countArrAy = this.countArr;
      if (countArrAy) {
        for (let i = 0; i < countArrAy.length; i++) {
          if (countArrAy[i].val) {
            count.push(Number(countArrAy[i].val));
          }
        }
      }

      this.resultTotal = QuestionnaireSum(count, this.whichPage).num;
      this.resultTitle = this.$t(`langcfg.${QuestionnaireSum(count, this.whichPage).bkStr}`);
    },
    // 中文算法拿总分，结果
    dealWidthOSDI(data) {
      this.follow = true;
      let OSDI = [];
      OSDI = data || this.countArr;

      this.historyQuestionOSDI = OSDI;
      this.countArr = OSDI;
      this.noCheckArr = [];
      let resCount = 0;
      this.resultTotal = QuestionnaireOSDI(OSDI).Osumtext;
      this.resultTitle = this.$t(`langcfg.${QuestionnaireOSDI(OSDI).bkStr}`);
      if (this.diaFlag) {
        for (let i = 0; i < this.historyQuestionOSDI.length; i++) {
          if (this.historyQuestionOSDI[i] === undefined) {
            resCount++;
            this.noCheckArr.push({ id: i });
          }
        }
        if (resCount === this.historyQuestionOSDI.length) {
          this.historyQuestionOSDI = [];
        }
        this.glandloss(this.countArr);
      }
    },
    dealWidthDryEyeMain(data) {
      this.follow = true;
      let DryEyeMain = [];
      this.noCheckArr = [];
      let dealWidthDryEyeMainData;
      DryEyeMain = data || this.countArr;

      this.countArr = DryEyeMain;
      dealWidthDryEyeMainData = DryEyeMain;
      this.DryEyeMainCopy = DryEyeMain;
      let resCount = 0;
      this.resultTotal = QuestionnaireDryEyeMain(this.countArr).num;
      this.resultTitle = this.$t(`langcfg.${QuestionnaireDryEyeMain(this.countArr).bkStr}`);
      if (this.diaFlag) {
        for (let i = 0; i < dealWidthDryEyeMainData.length; i++) {
          if (dealWidthDryEyeMainData[i] === undefined || dealWidthDryEyeMainData[i] === "") {
            resCount++;
            this.noCheckArr.push({ id: i });
          }
        }
        if (resCount === dealWidthDryEyeMainData.length) {
          this.countArr = [];
        }
        this.glandloss(this.countArr);
      }
    },
    hideDialog() {
      this.dialogVisible = false;
    },
    // 显示弹窗
    showDialog() {
      this.diaFlag = true;
      this.language = window.settings.language;
      if (this.language === "zh_CN") {
        if (this.whichPage === "OSDI") {
          this.dealWidthOSDI();
        } else if (this.whichPage === "DryEyeMain") {
          this.dealWidthDryEyeMain();
        }
      } else if (this.language === "en_US" || this.language === "ja" || this.language === "it") {
        // 英文下新增OSDI
        if (this.whichPage === "OSDI") {
          this.dealWidthOSDI();
        } else {
          this.glandloss(this.countArr);
        }
      }
    },
    glandloss(val) {
      if (this.countArr.length < 1) {
        this.isCheckAllType = false;
        // 判断未选一题
        this.resultTitle = this.$t("langcfg.answerAllQuestions");
        this.follow = false;
      } else if (this.countArr.length === this.noCheckArr.length && this.countArr.length < 1) {
        this.isCheckAllType = false;
        this.resultTitle = this.$t("langcfg.answerAllQuestions");
        this.follow = false;
      } else {
        // 判断未选其中一题

        if (this.noCheckArr.length > 0) {
          this.follow = false;
          this.isCheckAllType = false;
          let title = "";
          let titleArr = [];
          for (let i = 0; i < this.noCheckArr.length; i++) {
            if (titleArr.indexOf(this.noCheckArr[i]) === -1) {
              titleArr.push(this.noCheckArr[i]);
              if (this.whichPage === "McMonnies") {
                if (this.noCheckArr[i].id === -1) {
                  title =
                    "</br>" +
                    this.noCheckArr[i].name +
                    "(" +
                    this.$t("langcfg.txtRequired") +
                    ")" +
                    ",";
                } else {
                  title += this.noCheckArr[i].id + ",";
                }
              } else {
                title += this.noCheckArr[i].id + 1 + ",";
              }
            }
          }
          title = title.substring(0, title.length - 1);
          this.resultTitle = this.$t("langcfg.txtUnselected") + title;
        } else {
          this.isCheckAllType = true;
          this.follow = true;
          // if (this.whichPage === 'OSDI') {
          //   this.resultTotal = QuestionnaireOSDI(this.countArr).Osumtext
          //   this.resultTitle = this.$t(
          //     `langcfg.${QuestionnaireOSDI(this.countArr).bkStr}`
          //   )
          // } else if (this.whichPage === 'DryEyeMain') {
          //   this.resultTotal = QuestionnaireDryEyeMain(this.countArr).num
          //   this.resultTitle = this.$t(
          //     `langcfg.${QuestionnaireDryEyeMain(this.countArr).bkStr}`
          //   )
          // }
        }
      }
      this.dialogVisible = true;
      this.diaFlag = false;
    },
    // 提交最后结果
    submit() {
      if (this.whichPage === "Speed") {
        this.historyQuestionSpeed = this.countArr;
      } else if (this.whichPage === "DEQ") {
        this.historyQuestionDEQ = this.countArr;
      } else if (this.whichPage === "McMonnies") {
        this.historyQuestionMcMonnies = this.countArr;
      }
      this.update();
      this.disabled = false;
      this.dialogVisible = true;
    },
    update() {
      if (this.whichPage === "DryEyeMain") {
        this.addRecordMethod_DryEyeMain();
      } else {
        this.addRecordMethod();
      }
      this.showHistory();
    },
    addRecordMethod_DryEyeMain() {
      if (this.DryEyeMainCopy.length > 0) {
        this.currentRecord.content.userQuestionnaire.DryEyeMain = this.DryEyeMainCopy;
      }
      this.isCheckAllType = true;
      this.currentRecord.content.userQuestionnaire.diagnosed = true;
      this.$bus.$emit(EVENTS.updateData, this.currentRecord, {}, {}, () => {
        // this.resultTitle = this.$t('langcfg.txtSubmitSuccessful')
        this.dialogVisible = false;
      });
    },
    addRecordMethod() {
      if (this.historyQuestionSpeed) {
        this.currentRecord.content.userQuestionnaire.Speed = this.historyQuestionSpeed;
      }
      if (this.historyQuestionDEQ) {
        this.currentRecord.content.userQuestionnaire.DEQ = this.historyQuestionDEQ;
      }
      if (this.historyQuestionMcMonnies) {
        this.currentRecord.content.userQuestionnaire.McMonnies = this.historyQuestionMcMonnies;
      }
      if (this.historyQuestionOSDI) {
        this.currentRecord.content.userQuestionnaire.OSDI = this.historyQuestionOSDI;
      }
      this.isCheckAllType = true;
      this.currentRecord.content.userQuestionnaire.diagnosed = true;
      this.$bus.$emit(EVENTS.updateData, this.currentRecord, {}, {}, () => {
        this.dialogVisible = false;
      });
    },
    questionnaireExists() {
      return (
        isDefined(this.currentRecord) &&
        isDefined(this.currentRecord.content) &&
        isDefined(this.currentRecord.content.userQuestionnaire)
      );
    },
    // 制作ejs
    async renderEjs(url, renderobj, callback) {
      try {
        return await ejs.renderFile(url, renderobj);
      } catch (e) {
        return Promise.reject(e);
      }
    }
  },
  components: {
    McMonnies,
    DEQ,
    Speed,
    OSDI,
    DryEyeMain
  }
};
</script>
<style lang="less" scoped>
.questionNaire {
  width: 100%;
  .questionNaireCon {
    width: 100%;
    margin: auto;
    background: #fff;
    overflow: auto;
  }
  .dialog-footer {
    display: flex;
    margin-top: 10px;
    padding: 0 16px;

    .el-button {
      width: 100%;
      border: 1px solid;
      // padding: 10px;
      padding-left: 10px;
    }
    /deep/ .el-input__inner {
      text-align: center;
    }
  }
  .Qoption {
    width: 450px;
    line-height: 75px;
    height: 75px;
    text-align: center;
    border-bottom: 1px solid rgba(139, 138, 138, 0.69);
    transition: 0.5s;
  }
  /deep/ .el-scrollbar .Qoption:last-child {
    border: none;
  }
  /deep/ .el-scrollbar .Qoption:hover {
    cursor: pointer;
    background: rgba(255, 255, 255, 0.3);
  }
  /deep/ .el-input__inner {
    font-size: 23px !important;
    line-height: 80px !important;
    height: 80px !important;
  }
}
.el-scrollbar .Qoption:last-child {
  border: none;
}
.el-scrollbar .Qoption:hover {
  cursor: pointer;
  background: rgba(255, 255, 255, 0.3);
}
.resultTotal {
  font-size: 24px;
  color: white;
  line-height: 60px;
}
.resultTitle {
  font-size: 24px;
  color: white;
  line-height: 60px;
}
.resultPrompt {
  font-size: 24px;
  color: white;
  line-height: 60px;
  border-top: 1px solid gray;
}
.resultPrompt-txt {
  text-align: center;
  font-size: 30px;
  margin-bottom: 20px;
}
.resultBut {
  border: 1px solid rgba(151, 151, 151, 0.73);
  min-width: 120px;
  line-height: 45px;
  text-align: center;
  font-size: 22px;
  cursor: pointer;
  transition: 0.5s;
}
.resultBut:hover {
  background: rgba(255, 255, 255, 0.3);
}
.btnItem {
  font-size: 28px;
  flex: 1;
}
.btnText {
  font-size: 28px;
  flex: 1;
  color: #ffffff;
  resize: none;
  outline: none;
  border: none;
  text-align: center;
  height: 80px;
  white-space: normal;
}
.YMCfont {
  font-family: YMC;
}
/deep/ .el-input__suffix-inner {
  pointer-events: none;
}
/deep/ .el-input .el-input__suffix {
  line-height: 80px;
  height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/QuestionNaire.vue